<template>
    <div class="audio_msg_box" @click="$downapppop.open">
        <dl class="audio_msg_content">
            <dt>
                <img :src="require('@/assets/images/icon_audio@2x.png')" alt="" />
            </dt>
            <dd>
                <h4>语音消息</h4>
                <div></div>
                <p>
                    <span>00:00</span>
                    <span>{{strToTimeStr(audioLen)}}</span>
                </p>
            </dd>
        </dl>
    </div>
</template>
<script>
export default {
    name: 'imageViewpoint',
    props: {
        audioLen: Number,
    },
    created() {},
    methods: {
        strToTimeStr(str) {
            let minuteStr = Math.floor(+str / 60);
            let secondStr = +str % 60;
            minuteStr = minuteStr < 10 ? '0' + minuteStr : minuteStr;
            secondStr = secondStr < 10 ? '0' + secondStr : secondStr;
            return minuteStr + ':' + secondStr;
        }
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
//语音消息
.audio_msg_box{
  padding:0 14px 12px;
  .audio_msg_content{
    // width: 100%;
    height: 70px;
    background: #F7F7F7;
    padding: 9px 15px 8px 12px;
    display: flex;
    align-items: center;
    >dt{
      width: 37px;
      height: 37px;
      overflow: hidden;
      flex-shrink: 0;
      >img{
        width: 100%;
        height: 100%;
      }
      
    }
    >dd{
      height: 100%;
      padding: 0 15px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex:1;
      >h4{
        font-size: 15px;
        line-height: 21px;
      }
      >div{
      height:2px;
      border-radius:1px;
      background: #E9E9E9;
      }
      >p{
        font-size: 12px;
        line-height: 18px;
        color:#939393;
        display: flex;
        justify-content: space-between;
      }
    }
  }
}
</style>